import { Box, BoxProps, Heading, Text } from '@chakra-ui/react';

interface ISectionGroup {
  children: React.ReactNode;
  heading?: React.ReactNode;
  description?: React.ReactNode;
  'data-selector'?: string;
  boxProps?: BoxProps;
}

export const SectionGroup = (props: ISectionGroup) => {
  const { children, heading, description, boxProps, 'data-selector': dataSelector } = props;
  return (
    <Box className="hand-section" data-selector={dataSelector} {...boxProps}>
      {heading && (
        <Heading as="h2" fontSize={'2xl'} mb={4}>
          {heading}
        </Heading>
      )}

      {description && <Text mb={4}>{description}</Text>}

      {children}
    </Box>
  );
};
